import React from 'react'
import AboutMe from '../about-me';
import Header from '../header';
import HomeStyled from './home-style';
import Skills from '../skills';
import Portfolio from '../portfolio';
import Contact from '../contact';

const Home = () => {
    const introText = "APISec University ACP certified full stack developer with 4+ year of experience in Logistics management app, ERP software and freelancing. Experienced in building secured, scalable, performance and user centric web application."

    const onScroll = (activeContainer) => {
        const element = document.getElementById(activeContainer);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }

    return (
        <HomeStyled>
            <Header handleMenuClick={onScroll} />
            <div id="about-me" className="container" >
                <AboutMe introText={introText} />
            </div>
            <div className='container' id="intro-home">
                <div id="intro">
                    <h2>Intro</h2>
                    <p>
                        {introText}
                    </p>
                </div>
            </div>
            <div id="skills" className="container">
                <Skills />
            </div>
            <div id="portfolio" className="container">
                <Portfolio />
            </div>
            <div id="contact" className="container">
                <Contact />
            </div>
        </HomeStyled>
    )
}

export default Home;